import * as React from 'react';
import { DateRangePickerProps, DateRangePicker } from './DateRangePicker';
import { UseDateRangePickerArgs, useDateRangePicker } from './useDateRangePicker';

export const ControlledDateRangePicker = (
    props: Pick<DateRangePickerProps, 'className' | 'style'> & UseDateRangePickerArgs,
): JSX.Element => {
    const [pickerProps] = useDateRangePicker(props);
    return <DateRangePicker {...pickerProps} className={props.className} style={props.style} type={props.type} />;
};
ControlledDateRangePicker.displayName = 'ControlledDateRangePicker';
